/**
 * Patients API
 * All patient-related API calls
 */

import { apiClient } from './config';

/**
 * Fetch paginated patients with filters
 */
export const fetchPatientsWithPagination = async (params) => {
  const response = await apiClient.get('/patient-profiles-with-form-details-with-pagination', {
    params: {
      page: params.page,
      pageSize: params.pageSize,
      search: params.search,
      status: params.status,
      formStatusFilters: params.formStatusFilters,
      showDeceased: params.showDeceased,
      minAge: params.minAge,
      maxAge: params.maxAge,
    },
  });
  return response.data;
};

/**
 * Fetch single patient profile by ID
 */
export const fetchPatientProfile = async (customerId) => {
  const response = await apiClient.get(`/patient-profiles/${customerId}`);
  return response.data;
};

/**
 * Update patient profile
 */
export const updatePatientProfile = async (patientId, data) => {
  const response = await apiClient.put(`/patient-profiles/${patientId}`, data);
  return response.data;
};

/**
 * Update patient last opened timestamp
 */
export const updatePatientLastOpened = async (patientId) => {
  const response = await apiClient.put(`/patients/${patientId}/last-opened`, {});
  return response.data;
};
